import React, { useEffect, useState, useMemo } from 'react'
import { acquireConsumer, releaseConsumer } from '@shared/actionCableConsumer'

export const useStreamerKlipCues = (actionCableUrl, _streamerKlipCues, setSubscribed) => {
    const [streamerKlipCues, setStreamerKlipCues] = useState(_streamerKlipCues)

    useEffect(() => {
        setStreamerKlipCues(_streamerKlipCues)
    }, [_streamerKlipCues])

    useEffect(() => {
        if (!actionCableUrl) {
            setSubscribed(false)
            return undefined
        }

        setSubscribed(false)

        const consumer = acquireConsumer(actionCableUrl)
        const subscription = consumer.subscriptions.create({ channel: 'StreamerKlipCuesChannel' }, {
            received: (data) => {
                switch (data.type) {
                    case 'klip_cue_created':
                        setStreamerKlipCues(prev => [...prev, data.streamer_klip_cue])
                        break
                    case 'klip_cue_updated':
                        setStreamerKlipCues(prev => prev.map(kiq => kiq.id === data.streamer_klip_cue.id ? data.streamer_klip_cue : kiq))
                        break
                    case 'klip_cue_destroyed':
                        setStreamerKlipCues(prev => prev.filter(kiq => kiq.id !== data.streamer_klip_cue.id))
                        break
                    case 'klip_cues_cleared':
                        setStreamerKlipCues([])
                        break
                }
            },
            connected: () => {
                setSubscribed(true)
            },
            disconnected: () => {
                setSubscribed(false)
            },
            rejected: () => {
                setSubscribed(false)
                console.warn('StreamerKlipCuesChannel subscription rejected')
            }
        })

        return () => {
            setSubscribed(false)
            subscription.unsubscribe()
            releaseConsumer(actionCableUrl)
        }
    }, [actionCableUrl, setSubscribed])

    const sortedCue = useMemo(() => {
        return [...streamerKlipCues].sort((a, b) => (a.position || 0) - (b.position || 0))
    }, [streamerKlipCues])

    return {
        streamerKlipCues: sortedCue,
        setStreamerKlipCues,
        removeTestKlipCue: () => {
            setStreamerKlipCues(prev => prev.filter(skq => skq.status !== 'test'))
        },
    }
}
